import { render, staticRenderFns } from "./formGroupTextArea.vue?vue&type=template&id=58c44aa4"
import script from "./formGroupTextArea.vue?vue&type=script&lang=js"
export * from "./formGroupTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports